import type { TFunction } from "i18next";
import type { DefinitionTooltipInfo } from "src/components/common";
import type { PaidMediaOverviewPlatform } from "src/services/PaidMediaOverviewAPI";
import { getOverviewTooltip } from "../../utils/paidMediaOverviewTooltips";

const PLATFORM_SPECIFIC_KPIS = new Set([
  "totalSpend",
  "paidRevenue",
  "paidPurchases",
  "blendedCpp",
]);

const PLATFORM_SPECIFIC_REPORTS: PaidMediaOverviewPlatform[] = ["tiktok_ads", "snapchat_ads"];

/** KPI-card tooltips for Snapchat/TikTok platform reports; other metrics keep overview copy. */
export function getPlatformReportKpiTooltip(
  t: TFunction,
  tooltipId: string,
  platform: PaidMediaOverviewPlatform
): DefinitionTooltipInfo {
  if (PLATFORM_SPECIFIC_REPORTS.includes(platform) && tooltipId === "cpc") {
    return {
      description: t("googleAdsReport.kpiTooltips.cpc.description"),
      formula: t("googleAdsReport.kpiTooltips.cpc.formula"),
    };
  }

  if (
    PLATFORM_SPECIFIC_REPORTS.includes(platform) &&
    PLATFORM_SPECIFIC_KPIS.has(tooltipId)
  ) {
    const base = `platformAdsReport.tooltips.${platform}.${tooltipId}`;
    const description = t(`${base}.description`, { defaultValue: "" });
    const formula = t(`${base}.formula`, { defaultValue: "" });

    if (description.trim() || formula.trim()) {
      return {
        description: description.trim(),
        formula: formula.trim() || undefined,
      };
    }
  }

  return getOverviewTooltip(t, tooltipId, "platform");
}
